import { withGlobal } from "components/global/GlobalWrapper";
import { NewInvoice } from "./NewInvoice";
import { residentPaymentsReducers } from "components/stores/resident_payments/reducers";

export default withGlobal(NewInvoice, { reducers: residentPaymentsReducers })
